<bizz-modal modalSize="xs" [headerTemplate]="headerTemplateRef"
    [contentTemplate]="contentTemplateRef" [footerTemplate]="footerTemplateRef" [showCloseButton]="false"></bizz-modal>

<ng-template #headerTemplateRef>
    <div class="modal-header">
        <h1 class="mb-5 text-center font-title text-xl font-bold text-default">
            {{ 'Title_ReAuthenticationRequired' | translate }}</h1>
    </div>
    <hr class="my-5" />
</ng-template>

<ng-template #contentTemplateRef>
    <div class="mt-6 flex w-full items-center gap-4 rounded bg-yellow-500/20 p-4 text-button">
        <bizz-icon iconName="circle-exclamation" class="size-8 text-yellow-500"></bizz-icon>
        {{ 'Info_ReauthenticateRequired' | translate }}
    </div>
</ng-template>

<ng-template #footerTemplateRef>
    <div class="modal-buttons">
        <button class="save min-w-16" [disabled]="!networkService.isOnline" (click)="dialogRef.close(true)">
            {{ 'Login' | translate }}
        </button>
    </div>
</ng-template>